var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Report, Property 2=Active"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9311 11.8527C47.1321 11.461 48 10.3318 48 9C48 7.34315 46.6569 6 45 6C43.3431 6 42 7.34315 42 9C42 9.44352 42.0962 9.86456 42.269 10.2434L36.1728 24.1155C36.0296 24.1565 35.8909 24.2078 35.7573 24.2687L20.9171 16.2967C20.6006 14.9792 19.4147 14 18 14C16.3431 14 15 15.3431 15 17C15 17.374 15.0684 17.732 15.1934 18.0621L4.25763 39.0926C2.95984 39.4229 2 40.5994 2 42C2 43.6569 3.34315 45 5 45C6.65685 45 8 43.6569 8 42C8 41.626 7.93156 41.268 7.80652 40.9378L18.7414 19.9077C18.838 19.8831 18.9328 19.8539 19.0254 19.8202L34.1527 27.9475C34.5494 29.14 35.6743 30 37 30C38.6569 30 40 28.6569 40 27C40 26.5967 39.9204 26.212 39.7761 25.8607L45.9311 11.8527Z",
    fill: "#E0E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 25C29.6569 25 31 23.6569 31 22C31 20.3431 29.6569 19 28 19C26.3431 19 25 20.3431 25 22C25 23.6569 26.3431 25 28 25ZM28 25.5938L29.4808 28H35C35.5523 28 36 28.4477 36 29V35C36 35.5523 35.5523 36 35 36H21C20.4477 36 20 35.5523 20 35V29C20 28.4477 20.4477 28 21 28H26.5192L28 25.5938Z",
    fill: "#0075E3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportActive);
export default __webpack_public_path__ + "static/media/report-active.5de7e0a2f0db29c7f5a1aae43e915bf8.svg";
export { ForwardRef as ReactComponent };